<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  },
  created () {
    console.log(this.$store.state)
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store") ) {
        this.$store.replaceState(Object.assign({}, this.$store.state,JSON.parse(sessionStorage.getItem("store"))))
    } 

    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload",()=>{
        sessionStorage.setItem("store",JSON.stringify(this.$store.state))
    })
  }
}
</script>

<style>
html{
  font-size: 160px;
}
#app {
  font-family: 'Open Sans',sans-serif,"Helvetica Neue",Helvetica,Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
ul{
  margin: 0!important;
}
ul,li{
  list-style:none;
  margin: 0;
  padding: 0;
  line-height: 1;
}
img{
  object-fit: cover;
  width: auto;
  max-width: 100%;
}

/*包含以下五种的链接*/
a {
    text-decoration: none !important;
}
/*正常的未被访问过的链接*/
a:link {
    text-decoration: none !important;
}
/*已经访问过的链接*/
a:visited {
    text-decoration: none !important;
}
/*鼠标划过(停留)的链接*/
a:hover {
    text-decoration: none !important;
}
/* 正在点击的链接，鼠标在元素上按下还没有松开*/
a:active {
    text-decoration: none !important;
}
/* 获得焦点的时候 鼠标松开时显示的颜色*/
a:focus {
    text-decoration: none !important;
}
</style>
